import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  Row,
  Col,
  Select,
  Divider,
  useSelect,
  Button,
  Space,
  Spin,
} from '@pankod/refine-antd'
import type { RangePickerProps } from 'antd/es/date-picker'
import { useCreateMany, useDeleteMany, useGetIdentity, useShow, useTable, useUpdateMany } from '@pankod/refine-core'
import 'styles/custom.css'
import {
  IGrade,
  ISubject,
  IWorkRequest,
  ITopic,
  IBloomLevel,
  ICentaStandard,
  IDifficultyLevel,
  IQuestion,
  IQuestionType,
  ITeacherLevel,
  IReportTheme,
  ITheme,
  ISubTheme,
  IAspect,
  IWorkRequestStatus,
  INotification,
  IWorkRequestReviewer,
  IWorkRequestApprover,
  ICompetency,
  IStrand,
  ITNTaxonomy,
  IWorkRequestGrades,
} from 'interfaces'

import sendEmail from 'sendmail'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import CompetencySelector from 'components/formelements/competencycascader'
import { SingleValueType } from 'rc-cascader/lib/Cascader'
import { useEffect, useState } from 'react'
import React from 'react'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'
import { deleteWorkRequestGrades, getReportThemeBySubject } from 'gql/query'
import { useUserContext } from 'context/user'
import { useBloomsLevel, useDifficultyLevels } from 'utility/masterData'

type CreateWorkRequestProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  refreshData: any
  close: any
}

export const EditPaperWorkRequest: React.FC<CreateWorkRequestProps> = ({ modalProps, formProps, record, refreshData, close }) => {
  const { data: user } = useGetIdentity()
  const { qcreatorList, qreviewerList, qapproverList, vcreatorList, subjectInChargeUsers } = useUserContext()
  const [selectedValue, setSelectedValue] = useState<SingleValueType>([])
  const [defaultValue, setDefaultValue] = useState<SingleValueType>([])
  const [saveAsDraft, setSaveDraft] = useState(false)
  const [requestType, setRequestType] = useState('')
  // const [qcreatorList, setCreatorList] = useState([] as any[])
  // const [qreviewerList, setReviewerList] = useState([] as any[])
  // const [qapproverList, setApproverList] = useState([] as any[])
  // const [vcreatorList, setVariantCreatorList] = useState([] as any[])
  const [selectedReviewers, setSelectedReviewers] = useState<string[]>([])
  const [reviewers, setReviewers] = useState<object[]>([])
  const [selectedReviewerIds, setSelectedReviewerIDS] = useState<string[]>([])
  const [selectedReviewersList, setSelectedReviewerList] = useState<string[]>([])
  const [selectedApproverIds, setSelectedApproverIDS] = useState<string[]>([])
  const [newAddedIds, setNewAddedIDS] = useState<number[]>([])
  const [allReviewers, setAllReviewers] = useState<object[]>([])
  const [totalVariantCount, setTotalVariantCount] = useState(0)
  const [questionCount, setQuestionCount] = useState(5)
  const [taxonomyfilter, setTaxonomyFilter] = useState([])
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [showApprover, setShowApprover] = useState<boolean>(false)

  const [themeQueryEnabled, setThemeQueryEnabled] = useState<boolean>(false)
  const [subThemeQueryEnabled, setSubThemeQueryEnabled] = useState<boolean>(false)
  const [TopicQueryEnabled, setTopicQueryEnabled] = useState<boolean>(false)
  const [reportThemeQueryEnabled, setReportThemeQueryEnabled] = useState<boolean>(false)

  const [selectedGrades, setSelectedGrades] = useState([] as any[])
  const [workRequestReviewers, setWorkRequestReviewers] = useState([] as any[])
  const [workRequestApprovers, setWorkRequestApprovers] = useState([] as any[])
  const [paperWorkRequestType, setPaperWorkRequestType] = useState<string>('Normal')
  const bloomlevelSelectProps = useBloomsLevel(modalProps?.visible)
  const difficultylevelSelectProps = useDifficultyLevels(modalProps?.visible)
  // const [subjectInchargeList, setSubjectInchargeList] = useState<any[]>([])
  var notification_arr: object[] = []
  const [subjectFilter, setSubjectFilter] = useState<any[]>([])
  var mail_arr: object[] = []
  const [disableSaveBtn, setDisableSaveBtn] = useState(false)
  const [validation, setValidation] = useState({
    question_type_id: true,
    subject_id: true,
    creator_id: true,
  })
  const inputRef = React.useRef<HTMLButtonElement>(null)
  const { mutate } = useCreateMany<INotification>()
  const { mutate: createReviewers } = useCreateMany<IWorkRequestReviewer>()
  const { mutate: createApprovers } = useCreateMany<IWorkRequestApprover>()
  const { mutate: updateReviewers } = useDeleteMany<IWorkRequestReviewer>()
  const { mutate: updateApprovers } = useDeleteMany<IWorkRequestApprover>()
  const { mutate: createGrades } = useCreateMany<IWorkRequestGrades>()
  const { mutate: deleteGrades } = useDeleteMany<IWorkRequestGrades>()
  const { selectProps: gradeSelectProps } = useSelect<IGrade>({
    resource: 'grades',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible && !!record?.id },
  })
  // const { selectProps: questionSelectProps } = useSelect<IQuestion>({
  //   resource: 'questions',
  //   optionLabel: 'title',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'title'],
  //   },
  //   sort: [{ field: 'title', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'title',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })
  // const { selectProps: teacherlevelSelectProps } = useSelect<ITeacherLevel>({
  //   resource: 'teacher_levels',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'id', order: 'asc' }],
  // })
  // const { selectProps: topicSelectProps } = useSelect<ITopic>({
  //   resource: 'topics',
  //   fetchSize: 500,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })
  // const { selectProps: bloomlevelSelectProps } = useSelect<IBloomLevel>({
  //   resource: 'blooms_levels',
  //   optionLabel: 'name',
  //   fetchSize: 100,
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'order', order: 'asc' }],
  // })
  // const { selectProps: centastandardSelectProps } = useSelect<ICentaStandard>({
  //   resource: 'centa_standards',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })
  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible && !!record?.id },
  })
  // const { selectProps: difficultylevelSelectProps } = useSelect<IDifficultyLevel>({
  //   resource: 'difficulty_levels',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'order', order: 'asc' }],
  // })
  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'subjects',
    fetchSize: 200,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible && !!record?.id },
  })

  const onFinish = async (values: any) => {
    setDisableSaveBtn(true)

    let approverData: object[] = []
    let allApproverData: object[] = []
    allReviewers.map((item: any, i: any) => {
      delete values['approver_ids_' + i]
      delete values['reviwer_id_selected_' + i]

      if (selectedReviewerIds.includes(item?.reviewer?.id)) {
        item?.ap_ids.map((ids: any) => {
          allApproverData.push(ids)
        })
        approverData.push({ reviwer_id_selected: item?.reviewer?.id, approver_ids: item?.ap_ids })
      }
    })
    allApproverData = allApproverData.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) == index
    })

    //subject_incharge_id
    const subjectInchargeDetails = subjectInChargeUsers?.filter(user => user?.id === values?.subject_incharge_id)[0]
    mail_arr.push({
      subject: 'Work Request Created and assigned to you',
      to: [{ name: subjectInchargeDetails?.displayName, email: subjectInchargeDetails?.email }],
      htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. You can assign creators and reviewers and approvers as per your requirements.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
    })
    notification_arr.push({
      description: `You are assigned as the subject incharge for work request ${values?.name} `,
      sender: user?.id,
      recepient: subjectInchargeDetails?.user?.id,
      source_name: 'work_requests',
      title: 'New Task',
      recepient_user_role: 'subjectincharge',
    })

    if (JSON.stringify(values?.reviewer_ids) !== '{}' && values?.reviewer_ids !== null && values?.reviewer_ids !== undefined) {
      values?.reviewer_ids.map((item: any) => {
        notification_arr.push({
          description:
            record?.status === 'Draft' && !saveAsDraft ? `work request ${values?.name} is Created` : `work request ${values?.name} is updated`,
          sender: user?.id,
          recepient: item,
          source_name: 'work_requests',
          title: 'New Task',
          redirect_id: record?.id,
          redirect_component: 'show',
          recepient_user_role: 'qreviewer',
        })
        let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === item)[0]
        mail_arr.push({
          subject: record?.status === 'Draft' && !saveAsDraft ? 'Work Request Created' : 'Work Request Updated',
          to: [{ name: reviewerDetails?.displayName, email: reviewerDetails?.email }],
          htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} is updated.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
        })
      })
    }
    if (approverData !== null && approverData !== undefined && approverData?.length > 0) {
      approverData?.map((item: any) => {
        item?.approver_ids.map((approver: any) => {
          notification_arr.push({
            description:
              record?.status === 'Draft' && !saveAsDraft ? `work request ${values?.name} is Created` : `work request ${values?.name} is updated`,
            sender: user?.id,
            recepient: approver,
            source_name: 'work_requests',
            title: 'New Task',
            redirect_id: record?.id,
            redirect_component: 'show',
            recepient_user_role: 'qapprover',
          })
          let approverDetails = qapproverList.filter((appUser: any) => appUser?.id === approver)[0]
          mail_arr.push({
            subject: record?.status === 'Draft' && !saveAsDraft ? 'Work Request Created' : 'Work Request Updated',
            to: [{ name: approverDetails?.displayName, email: approverDetails?.email }],
            htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} is updated.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
          })
        })
      })
    }
    if (values?.creator_id !== '' && values?.creator_id !== null && values?.creator_id !== undefined) {
      notification_arr.push({
        description:
          record?.status === 'Draft' && !saveAsDraft ? `work request ${values?.name} is Created` : `work request ${values?.name} is updated`,
        sender: user?.id,
        recepient: values?.creator_id,
        source_name: 'work_requests',
        title: 'New Task',
        redirect_id: record?.id,
        redirect_component: 'show',
        recepient_user_role: requestType === 'Q' ? 'qcreator' : 'variantcreator',
      })
      let creatorDetails = []
      if (requestType === 'Q') {
        creatorDetails = qcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }
      if (requestType === 'V') {
        creatorDetails = vcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }

      mail_arr.push({
        subject: record?.status === 'Draft' && !saveAsDraft ? 'Work Request Created' : 'Work Request Updated',
        to: [{ name: creatorDetails?.displayName, email: creatorDetails?.email }],
        htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} is updated. You have to create ${values?.count} questions.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
      })
    }
    let count = questionCount
    if (requestType === 'V') {
      count = 0
      values?.variant_options?.map((item: any) => {
        count = count + parseInt(item?.variant_count)
      })
    }
    formProps.form?.resetFields()
    setAllReviewers([])
    if (saveAsDraft === true) {
      setSaveDraft(false)
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          count: count,
          status: 'Draft',
          approver_ids: approverData,
          all_approver_ids: allApproverData,
          subject_id: values?.subject_id !== '' ? values?.subject_id : null,
          question_type_id: values?.question_type_id !== '' ? values?.question_type_id : null,
          creator_id: values?.creator_id !== '' ? values?.creator_id : null,
        })
      )
    } else if (paperWorkRequestType === 'Bulk') {
      formProps.onFinish && formProps.onFinish({ ...values, approver_ids: null, creator_id: null, all_approver_ids: 'null', reviewer_ids: null })
    } else {
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          status: record?.status === 'Draft' ? 'Open' : record?.status,
          count: count,
          approver_ids: approverData,
          all_approver_ids: allApproverData,
        })
      )
    }
  }

  const { filters, setFilters, tableQueryResult, sorter } = useTable<ITopic>({
    resource: 'topics',
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    initialPageSize: 500,
    queryOptions: { enabled: !!modalProps?.visible && !!record?.id },
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    initialPageSize: 500,
    metaData: { fields: ['id', 'name', 'subject_id'] },
    queryOptions: { enabled: !!modalProps?.visible && !!record?.id },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    initialPageSize: 500,
    metaData: { fields: ['id', 'name', 'theme_id'] },
    queryOptions: { enabled: !!modalProps?.visible && !!record?.id },
  })
  const {
    filters: questionFilter,
    setFilters: setQuestionFilters,
    tableQueryResult: questionResult,
  } = useTable<IQuestion>({
    resource: 'questions',
    metaData: { fields: ['id', 'title'] },
    initialPageSize: 500,
    queryOptions: { enabled: !!modalProps?.visible && !!record?.id },
  })
  // const { selectProps: reportThemeProps } = useSelect<IReportTheme>({
  //   resource: 'report_themes',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })
  // const { selectProps: workrequestStatusSelectProps } = useSelect<IWorkRequestStatus>({
  //   resource: 'work_request_statuses',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })
  // const { selectProps: competencySelectProps } = useSelect<ICompetency>({
  //   resource: 'competencies',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })
  useEffect(() => {
    let arr: object[] = []
    let reviewer_arr: object[] = []
    let approver_arr: object[] = []
    if (record?.workRequestGrades?.length > 0) {
      record?.workRequestGrades?.map((item: any) => {
        arr.push(item?.id)
      })
      arr = arr.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })
      setSelectedGrades(arr)
    }
    if (record?.workRequestReviewers?.length > 0) {
      record?.workRequestReviewers?.map((item: any) => {
        reviewer_arr.push(item?.id)
      })
      reviewer_arr = reviewer_arr.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })
      setWorkRequestReviewers(reviewer_arr)
    }

    if (record?.workRequestApprovers?.length > 0) {
      record?.workRequestApprovers?.map((item: any) => {
        approver_arr.push(item?.id)
      })
      approver_arr = approver_arr.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })
      setWorkRequestApprovers(approver_arr)
    }
    setPaperWorkRequestType(record?.paper_wr_type)
  }, [record])

  useEffect(() => {
    setSaveDraft(false)
    setValidation({
      question_type_id: true,
      subject_id: true,
      creator_id: true,
    })

    setQuestionFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: record?.subject_id,
      },
    ])
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: record?.report_theme_id,
      },
    ])
  }, [record])
  useEffect(() => {
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: record?.subject_id,
      },
    ]
    setSubjectFilter(data)
  }, [record])
  useEffect(() => {
    if (record?.theme_id !== '' || record?.theme_id !== null) {
      subThemeFilters.pop()
      setSubThemeFilters([
        {
          field: 'theme_id',
          operator: 'eq',
          value: record?.theme_id,
        },
      ])
    }
  }, [record])
  useEffect(() => {
    if (record?.sub_theme_id !== '' || record?.sub_theme_id !== null) {
      filters.push({
        field: 'sub_theme_id',
        operator: 'eq',
        value: record?.sub_theme_id,
      })
      setFilters(filters)
    }
  }, [record])

  useEffect(() => {
    setRequestType(record?.request_type)
    if (record?.request_type === 'Q') {
      setQuestionCount(record?.count)
    } else {
      setTotalVariantCount(record?.count)
    }
  }, [record])
  const handleRequestType = (value: any) => {
    setRequestType(value)
    formProps?.form?.setFieldsValue({
      creator_id: null,
    })
  }
  const handleReportThemeChange = (value: { value: any }) => {
    themeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
    })
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleSubjectChange = (value: { value: any }) => {
    setSubjectFilter([])
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
      report_theme_id: null,
    })
    themeFilters.pop()
    questionFilter.pop()
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ]
    setSubjectFilter(data)
    setQuestionFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleThemeChange = (value: { value: any }) => {
    formProps.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
    })
    subThemeFilters.pop()
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleSubThemeChange = (value: { value: any }) => {
    formProps.form?.setFieldsValue({
      topic_id: null,
    })
    filters.pop()
    setFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  useEffect(() => {
    let arr: object[] = []
    let ids: string[] = []
    let r_arr: object[] = []
    let appr_list: any[] = []
    let ap_ids: any[] = []

    if (record?.approver_ids?.length > 0) {
      record?.approver_ids?.map((item: any) => {
        ap_ids = []
        appr_list = []

        ids.push(item?.reviwer_id_selected)
        item?.approver_ids.map((appr: any) => {
          ap_ids.push(appr)
          const result1 = qapproverList?.filter((list: any) => list?.id === appr)[0]
          appr_list.push(result1)
        })

        const result = qreviewerList?.filter((list: any) => list?.id === item?.reviwer_id_selected)[0]

        arr.push({ reviewer: result, approver_ids: appr_list, ap_ids: ap_ids, status: 'old' })
        r_arr.push(result)
      })
    } else if (record?.reviewer_ids?.length > 0) {
      record?.reviewer_ids?.map((item: any) => {
        ap_ids = []
        appr_list = []

        const result = qreviewerList?.filter((list: any) => list?.id === item)[0]?.user

        arr.push({ reviewer: result, approver_ids: appr_list, ap_ids: ap_ids, status: 'old' })
        r_arr.push(result)
      })
      // record?.workRequestReviewers?.length > 0 &&
      //   record?.workRequestReviewers?.map((item: any) => {
      //     if (record?.workRequestApprovers?.length > 0) {
      //       record?.workRequestApprovers?.map((approv: any) => {
      //         if (approv?.reviewer_id === item?.user_id) {
      //           var found = arr_approver.findIndex(function (doundIndex: any) {
      //             return doundIndex?.reviewer_id === approv.reviewer_id
      //           })
      //           if (found > -1) {
      //             arr_approver[found]?.approvers?.push(approv?.userByApprover?.displayName)
      //             // app_arr.push(approv?.userByApprover?.displayName)
      //             // arr_approver approvers[found]?.push(approv?.userByApprover?.displayName)
      //           } else {
      //             let app_arr: object[] = []
      //             app_arr.push(approv?.userByApprover?.displayName)
      //             arr_approver.push({
      //               reviewer_id: approv?.reviewer_id,
      //               reviewer_name: approv?.userByReviewerId[0]?.displayName,
      //               approvers: app_arr,
      //             })
      //           }
      //         } else {
      //           arr_approver.push({
      //             reviewer_id: item?.user_id,
      //             reviewer_name: item?.userByReviewerId?.displayName,
      //             approvers: [],
      //           })
      //         }
      //       })
      //     } else {
      //       arr_approver.push({
      //         reviewer_id: item?.user_id,
      //         reviewer_name: item?.userByReviewerId?.displayName,
      //         approvers: [],
      //       })
      //     }
      //   })
      // arr_approver = arr_approver.filter(
      //   (elem: any, index: any, self: any) =>
      //     self.findIndex((t: any) => {
      //       return t.reviewer_id === elem.reviewer_id
      //     }) === index
      // )
    }

    setSelectedReviewerIDS(ids)

    setAllReviewers(arr)
    if (record?.approver_ids?.length > 0 || record?.reviewer_ids?.length > 0) {
      setShowApprover(true)
    }
    setReviewers(arr)

    // setSelectedReviewerList(ids)
  }, [record])
  console.log('allXXXXXXXXXX', allReviewers, showApprover)
  const filterOptions = () => {
    let ids: string[] = []
    formProps?.form?.getFieldValue('approver_ids')?.map((item: any) => {
      ids.push(item?.reviwer_id_selected)
    })
    ids = ids.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) == index
    })
    setSelectedReviewerList(ids)
  }

  // const { selectProps: tntaxonomySelectProps } = useSelect<ITNTaxonomy>({
  //   resource: 'tn_taxonomys',
  //   fetchSize: 100,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name', 'competency_id'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   filters: taxonomyfilter,
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  // const { selectProps: strandSelectProps } = useSelect<IStrand>({
  //   resource: 'strands',
  //   fetchSize: 100,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name', 'teacher_level_id', 'taxonomy_id', 'competency_id'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   filters: strandfilter,
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  // const handleCompetencyChange = (value: { value: any }) => {
  //   formProps?.form?.setFieldsValue({
  //     taxonomy_id: null,
  //     teacher_level_id: null,
  //     strand_id: null,
  //   })
  //   let data: any = [
  //     {
  //       field: 'competency_id',
  //       operator: 'eq',
  //       value: value,
  //     },
  //   ]
  //   setTaxonomyFilter(data)
  //   setStrandFilter(data)
  // }
  // const handleTaxonomyChange = (value: { value: any }) => {
  //   formProps?.form?.setFieldsValue({
  //     teacher_level_id: null,
  //     strand_id: null,
  //   })
  //   let arr: any[] = [...strandfilter]
  //   let data: any = {
  //     field: 'taxonomy_id',
  //     operator: 'eq',
  //     value: value,
  //   }
  //   arr.push(data)

  //   setStrandFilter(arr)
  // }

  // const handleTeacherLevelChange = (value: { value: any }) => {
  //   formProps?.form?.setFieldsValue({
  //     strand_id: null,
  //   })
  //   let arr: any[] = [...strandfilter]
  //   let data: any = {
  //     field: 'teacher_level_id',
  //     operator: 'eq',
  //     value: value,
  //   }

  //   arr.push(data)
  //   setStrandFilter(arr)
  // }
  useEffect(() => {
    let arr: any[] = [...strandfilter]
    if (record?.comptency_id !== '' && record?.comptency_id !== null && record?.comptency_id !== undefined) {
      let data: any = [
        {
          field: 'competency_id',
          operator: 'eq',
          value: record?.comptency_id,
        },
      ]
      setTaxonomyFilter(data)
      // setStrandFilter(data)
    }
    if (record?.taxonomy_id !== '' && record?.taxonomy_id !== null && record?.taxonomy_id !== undefined) {
      let data: any = {
        field: 'taxonomy_id',
        operator: 'eq',
        value: record?.taxonomy_id,
      }
      arr.push(data)
      // setStrandFilter(arr)
    }
    if (record?.teacher_level_id !== '' && record?.teacher_level_id !== null && record?.teacher_level_id !== undefined) {
      let data: any = {
        field: 'teacher_level_id',
        operator: 'eq',
        value: record?.teacher_level_id,
      }
      arr.push(data)
    }
    setStrandFilter(arr)
  }, [record])
  // const getValueToRemove = () => {
  //   if (removedReviewerIds.length > 0) {
  //     let result: number[] = field_arr.filter((x: any) => !removedReviewerIds.includes(x))
  //     return result[0]
  //   } else return -1
  //   //   field_arr.filter((x: any) => !removedReviewerIds.includes(x))
  //   // }
  // }
  const addApprover = () => {
    setShowApprover(true)
  }
  const reviewerChange = (value: string[]) => {
    let arr: object[] = []
    let ids: string[] = []
    let all_data: object[] = [...allReviewers]
    let new_data: object[] = []

    if (value?.length > 0) {
      for (let i = 0; i < value?.length; i++) {
        const result1 = qreviewerList?.filter((item: any) => item?.id === value[i])[0]
        arr.push(result1)
        ids.push(value[i])
      }

      if (value?.length > selectedReviewerIds?.length) {
        let result_data = ids.filter(e => !allReviewers.find((item: any) => e == item.reviewer?.id))
        const data = qreviewerList?.filter((list: any) => list?.id === result_data[0])[0]

        all_data.push({ reviewer: data, approver_ids: [], ap_ids: [] })
      }
      if (value.length < selectedReviewerIds?.length) {
        all_data = all_data.filter((item: any) => ids.includes(item?.reviewer?.id))
      }
      ids = ids.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })

      setAllReviewers(all_data)
      setSelectedReviewerIDS(ids)
    } else {
      setAllReviewers([])
      setSelectedReviewerIDS([])
    }
  }
  const changeApprover = (value: string[], rid: string) => {
    allReviewers.map((item: any, index: any) => {
      if (item?.reviewer?.id === rid) {
        let app_data: object[] = []
        let app_ids: string[] = []
        if (app_ids === undefined) {
          app_ids = []
        }
        for (let i = 0; i < value?.length; i++) {
          app_data.push(qapproverList?.filter((list: any) => list?.id === value[i])[0])

          app_ids.push(qapproverList?.filter((list: any) => list?.id === value[i])[0]?.id)
          app_data = app_data.filter((thing: any, index: any, self: any) => index === self.findIndex((t: any) => t.id === thing.id))
          app_ids = app_ids.filter(function (item, index, inputArray) {
            return inputArray.indexOf(item) == index
          })
        }
        item['approver_ids'] = app_data
        item['ap_ids'] = app_ids
        item['status'] = 'new'
        setSelectedApproverIDS(app_ids)
      }
    })
  }
  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && current < dayjs()
  }

  const { selectProps: reportThemeSelectProps } = useSelect<IReportTheme>({
    resource: 'report_themes',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: subjectFilter,
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  console.log('recordxxxx', record)

  return (
    <Modal {...modalProps} title="Edit Work Request" okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          onFinish(values)
            .then(() => {
              let grade_array: object[] = []
              if (values?.grade_ids?.length > 0) {
                values?.grade_ids?.map((item: any) => {
                  grade_array.push({
                    grade_id: item,
                    work_request_id: record?.id,
                  })
                })
                if (selectedGrades?.length > 0) {
                  deleteGrades({
                    resource: 'work_request_grades',
                    ids: selectedGrades,
                  })
                }
                // deleteWorkRequestGrades(record?.id).then((resp: any) => {
                createGrades({
                  resource: 'work_request_grades',
                  values: grade_array,
                })
                // })
              }
              let reviwer_arr: object[] = []
              let approver_arr: object[] = []
              if (values?.reviewer_ids !== null && values?.reviewer_ids !== undefined && JSON.stringify(values?.reviewer_ids) !== '{}') {
                values?.reviewer_ids?.map((item: any) => {
                  reviwer_arr.push({ user_id: item, work_request_id: record?.id })
                })
                if (workRequestReviewers.length > 0) {
                  updateReviewers({
                    resource: 'work_request_reviewers',
                    ids: workRequestReviewers,
                  })
                }

                createReviewers({
                  resource: 'work_request_reviewers',
                  values: reviwer_arr,
                })
              }
              let approverData: object[] = []

              allReviewers.map((item: any, i: any) => {
                delete values['approver_ids_' + i]
                if (selectedReviewerIds.includes(item?.reviewer?.id))
                  approverData.push({ reviwer_id_selected: item?.reviewer?.id, approver_ids: item?.ap_ids })
              })
              if (approverData?.length > 0) {
                approverData?.map((item: any) => {
                  if (item?.approver_ids.length > 0) {
                    item?.approver_ids.map((approver: any) => {
                      approver_arr.push({ approver_id: approver, work_request_id: record?.id, reviewer_id: item?.reviwer_id_selected })
                    })
                  } else
                    item?.approver_ids.map((approver: any) => {
                      approver_arr.push({ approver_id: '', work_request_id: record?.id, reviewer_id: item?.reviwer_id_selected })
                    })
                })
                if (workRequestApprovers?.length > 0) {
                  updateApprovers({
                    resource: 'work_request_approvers',
                    ids: workRequestApprovers,
                  })
                }
                createApprovers({
                  resource: 'work_request_approvers',
                  values: approver_arr,
                })
              }
              if (!saveAsDraft) {
                sendEmail(mail_arr)
                mutate({
                  resource: 'notifications',
                  values: notification_arr,
                })
              }
              //  refreshData()
            })
            .then(() => {
              setDisableSaveBtn(false)
              close()
            })
        }
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Work Request Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={16}>
            <Form.Item label="Description" name="description">
              <Input disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={12}>
            <Form.Item label="Request Type" name="request_type" initialValue={'Q'} rules={[{ required: true }]}>
              <Select
                allowClear
                disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
                onChange={handleRequestType}
                options={[
                  { label: 'Question', value: 'Q' },
                  { label: 'Variant', value: 'V' },
                ]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={12}>
            <Form.Item label="Paper Work Request Type" name="paper_wr_type" initialValue={record?.paper_wr_type} rules={[{ required: true }]}>
              <Select
                allowClear
                // onChange={handleRequestType}
                onChange={value => setPaperWorkRequestType(value)}
                options={[
                  { label: 'Normal Request', value: 'Normal' },
                  { label: 'Urgent Request', value: 'Urgent' },
                ]}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} lg={8}>
              <Form.Item label="Status" name="status" initialValue={'Open'} rules={[{ required: true }]}>
                <Select {...workrequestStatusSelectProps} />
              </Form.Item>
            </Col> */}
          <Col xs={24} lg={8}>
            <Form.Item label="Question Type" name="question_type_id" rules={[{ required: validation?.question_type_id }]}>
              <Select
                allowClear
                {...questionTypeSelectProps}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Due Date"
              name="due_date"
              rules={[{ required: true }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker
                style={{ width: '100%' }}
                disabledDate={disabledDate}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item label="Grade" name="grade_ids" rules={[{ required: false }]}>
              <Select
                allowClear
                {...gradeSelectProps}
                showSearch={false}
                mode="multiple"
                disabled={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={8}>
            <Form.Item label="Subject" name="subject_id" rules={[{ required: validation?.subject_id }]}>
              <Select
                allowClear
                {...subjectSelectProps}
                onChange={handleSubjectChange}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Report Theme" name="report_theme_id" rules={[{ required: false }]}>
              <Select
                // disabled={
                //   formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false
                // }
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  !!record?.sub_section?.report_theme_id ||
                  (formProps?.form?.getFieldValue('subject_id') === undefined || formProps?.form?.getFieldValue('subject_id') == null ? true : false)
                }
                allowClear
                {...reportThemeSelectProps}
                onChange={handleReportThemeChange}
              />
            </Form.Item>
          </Col> */}
          <Col xs={24} lg={8}>
            <Form.Item label="Theme" name="theme_id" rules={[{ required: false }]}>
              <Select
                allowClear
                onChange={handleThemeChange}
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  !!record?.sub_section?.theme_id ||
                  (formProps?.form?.getFieldValue('report_theme_id') === undefined || formProps?.form?.getFieldValue('report_theme_id') == null
                    ? true
                    : false)
                }
              >
                {themeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Sub Theme" name="sub_theme_id" rules={[{ required: false }]}>
              <Select
                allowClear
                onChange={handleSubThemeChange}
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  !!record?.sub_section?.sub_theme_id ||
                  (formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false)
                }
              >
                {subThemeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Topic" name="topic_id" rules={[{ required: false }]}>
              {/* <TopicSelector /> */}
              {/* <Select {...topicSelectProps} /> */}
              <Select
                allowClear
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  !!record?.sub_section?.topic_id ||
                  (formProps?.form?.getFieldValue('sub_theme_id') === undefined || formProps?.form?.getFieldValue('sub_theme_id') == null
                    ? true
                    : false)
                }
              >
                {tableQueryResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Subject Incharge" name="subject_incharge_id" rules={[{ required: true }]}>
              <Select>
                {subjectInChargeUsers.length > 0 &&
                  subjectInChargeUsers.map(eachUser => (
                    <option key={eachUser?.id} value={eachUser?.id}>
                      {eachUser?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {/* --------------------- */}
          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate Bloom's taxonomy level"  name="bloom_level_id" rules={[{ required: false }]}>
              <Select 
              {...bloomlevelSelectProps} 
              allowClear 
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id"  rules={[{ required: false }]}>
              <Select 
              {...difficultylevelSelectProps} 
              allowClear 
              />
            </Form.Item>
          </Col>
          {/* ---------------------- */}
          {requestType === 'Q' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Number of Questions" name="count" initialValue={questionCount} rules={[{ required: true }]}>
                <Input onChange={e => setQuestionCount(parseInt(e.target.value))} />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
        <Row gutter={[16, 0]}>
          {requestType === 'Q' && paperWorkRequestType === 'Urgent' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Creator" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  allowClear
                  showSearch
                  // onSearch={value => searchUser('qcreator', value)}
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onChange={() => setResetCreatorData(true)}
                  disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
                >
                  {qcreatorList?.length > 0 &&
                    qcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          ) : requestType === 'V' && paperWorkRequestType === 'Urgent' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Variant Creator" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  // onChange={() => setResetVCreatorData(true)}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
                >
                  {vcreatorList?.length > 0 &&
                    vcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
                {/* <Select />{" "} */}
              </Form.Item>
            </Col>
          ) : null}
          {paperWorkRequestType === 'Urgent' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Reviewer" name="reviewer_ids" rules={[{ required: false }]} initialValue={selectedReviewers}>
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(value: any) => reviewerChange(value)}
                  defaultValue={selectedReviewers}
                  disabled={record?.reviewer_ids?.length > 0 && (record?.status === 'In Progress' || record?.status === 'Closed')}
                >
                  {qreviewerList?.length > 0 &&
                    qreviewerList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}

          {paperWorkRequestType === 'Urgent' ? (
            <Col xs={24} lg={24}>
              {showApprover
                ? allReviewers?.length > 0 &&
                  allReviewers.map((elem: any, i: any) => (
                    <Row
                      key={i}
                      gutter={[16, 0]}
                      style={{ display: selectedReviewerIds?.length > 0 && !selectedReviewerIds.includes(elem?.reviewer?.id) ? 'none' : 'flex' }}
                    >
                      <Col xs={24} lg={12}>
                        <Form.Item
                          label="Reviewer"
                          name={'reviwer_id_selected_' + i}
                          rules={[
                            {
                              required: false,
                              message: 'Select a Reviewer',
                            },
                          ]}
                        >
                          <Input
                            disabled={record?.reviewer_ids?.length > 0 && (record?.status === 'In Progress' || record?.status === 'Closed')}
                            placeholder={elem?.reviewer?.displayName}
                            defaultValue={elem?.reviewer?.displayName}
                            readOnly
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={8}>
                        <Form.Item label="Approver" name={'approver_ids_' + i} rules={[{ required: false, message: 'Select an Approver' }]}>
                          {elem?.ap_ids?.length > 0 ? (
                            <>
                              <Select
                                allowClear
                                showSearch
                                filterOption={(input: any, option: any) =>
                                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                // onSearch={value => searchUser('qapprover', value)}

                                mode="multiple"
                                defaultValue={elem?.ap_ids}
                                onChange={(value: any) => changeApprover(value, elem?.reviewer?.id)}
                                disabled={
                                  elem?.status !== 'new' &&
                                  elem?.ap_ids?.length > 0 &&
                                  (record?.status === 'In Progress' || record?.status === 'Closed')
                                }
                              >
                                {qapproverList?.length > 0 &&
                                  qapproverList?.map(item => (
                                    <option key={item?.id} value={item?.id}>
                                      {item?.displayName}
                                    </option>
                                  ))}
                              </Select>
                            </>
                          ) : (
                            <Select
                              allowClear
                              showSearch
                              filterOption={(input: any, option: any) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              mode="multiple"
                              disabled={elem?.approver_ids?.length > 0 && (record?.status === 'In Progress' || record?.status === 'Closed')}
                              defaultValue={elem?.ap_ids}
                              onChange={(value: any) => changeApprover(value, elem?.reviewer?.id)}
                            >
                              {qapproverList?.length > 0 &&
                                qapproverList?.map(item => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.displayName}
                                  </option>
                                ))}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  ))
                : null}
              {paperWorkRequestType === 'Urgent' ? (
                <Form.Item>
                  <Button
                    disabled={record?.approver_ids?.length > 0 && (record?.status === 'In Progress' || record?.status === 'Closed')}
                    type="dashed"
                    onClick={() => addApprover()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Approver
                  </Button>
                </Form.Item>
              ) : null}
            </Col>
          ) : null}
          {/* // :
            // null} */}

          {/* <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Tags
            </Divider>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Competency" name="competency_id" rules={[{ required: false }]}>
              <Select
                allowClear
                onChange={handleCompetencyChange}
                {...competencySelectProps}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="TN Taxonomy" name="taxonomy_id" rules={[{ required: false }]}>
              <Select
                allowClear
                onChange={handleTaxonomyChange}
                {...tntaxonomySelectProps}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Strand" name="strand_id" rules={[{ required: false }]}>
              <Select allowClear {...strandSelectProps} disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
              <Form.Item label="Teacher Level" name="teacher_level_id" rules={[{ required: false }]}>
                <Select
                  onChange={handleTeacherLevelChange}
                  {...teacherlevelSelectProps}
                  disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
                />
              </Form.Item>
            </Col> */}

          {/* <Col xs={24} lg={8}>
            <Form.Item label="Blooms Level" name="bloom_level_id" rules={[{ required: false }]}>
              <Select allowClear {...bloomlevelSelectProps} disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Difficulty Level" name="difficulty_level_id" rules={[{ required: false }]}>
              <Select allowClear {...difficultylevelSelectProps} disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} lg={8}>
              <Form.Item label="Question" name="question_id" rules={[{ required: false }]}>
                <Select />
              </Form.Item>
            </Col> */}

          {/* <Col xs={24} lg={8}>
              <Form.Item label="Report Theme" name="report_theme_id" rules={[{ required: false }]}>
                <Select {...reportThemeProps} disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
              </Form.Item>
            </Col> */}
          {requestType === 'V' ? (
            <>
              <Col xs={24} lg={24}>
                <Divider orientation="left" orientationMargin="0" className="primary">
                  Add Variants
                </Divider>
              </Col>
              <Col xs={24} lg={24}>
                <Form.List name="variant_options">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row gutter={[16, 0]}>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              {...restField}
                              label="Variant Question"
                              name={[name, 'question_id']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Missing Variant Question',
                                },
                              ]}
                            >
                              <Select allowClear>
                                {questionResult?.data?.data?.map(item => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.title}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={8}>
                            <Form.Item
                              {...restField}
                              label="Variant Count"
                              name={[name, 'variant_count']}
                              rules={[{ required: true, message: 'Missing Count' }]}
                            >
                              <Input placeholder="Variant Count" type="small" />
                            </Form.Item>
                          </Col>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Row>
                        // </Space>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Add Variants
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </>
          ) : null}
          <Form.Item name="updated_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
        <Row gutter={[16, 0]} justify="end" align="top">
          <Spin spinning={disableSaveBtn}></Spin>
          <Col xs={24} lg={8} style={{ display: 'flex', justifyContent: 'end' }}>
            <Space>
              <Button onClick={() => close()}>Cancel</Button>
              <Button type="primary" htmlType="submit" disabled={disableSaveBtn}>
                Submit
              </Button>

              <Button
                className="save-draft-btn"
                htmlType="submit"
                onClick={() => {
                  setValidation({ question_type_id: false, subject_id: false, creator_id: false })
                  setSaveDraft(true)
                }}
                hidden={record?.status === 'In Progress' || record?.status === 'Closed'}
              >
                Save Draft
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
